export const adamActionsConfig = [
    "conversation.chat.disable",
    "conversation.chat.enable",
    "conversation.state.change",
    "conversation.request.close",
    "conversation.typing.stop",
    "conversation.typing.start"
];
